import React, { useState } from "react";
import {
    Row,
    Col,
    Button,
    Accordion,
    Form,
    OverlayTrigger,
    Container,
} from "react-bootstrap";
import styles from "../../CSPCustomerPrerequisite.module.scss";
import { MCAError } from "../../../../../../../../../Utils/StaticMessages/GenericErrorMessages";
import {
    mcaAgreementDetnameRegEx,
    phoneOnChangeRegex,
} from "../../../../../../../../../Utils/RegExPatterns";
import { Box, Step, StepLabel, Stepper, Tooltip } from "@mui/material";
import Popup from "reactjs-popup";
import { TEXT_SECONDARY } from "../../../../../../../../../Utils/ColorsConfiguration";
import { XLg } from "react-bootstrap-icons";

const MCAAgreement = (props) => {
    const minMCAAgreementDate = "2015-01-01";
    const steps = ["Enter MCA details", "Accept Agreement", "Finalize Agreement"];
    const [activeStep, setActiveStep] = useState(0);
    const [buttonCheckstep1, setButtonCheckstep1] = useState(false);
    const [buttonCheckstep2, setButtonCheckstep2] = useState(false);
    const [iframe, setIframe] = useState(false);
    const [checkBoxStatus, setCheckBoxStatus] = useState(false);

    const handleKeyDown = (e) => {
        e.preventDefault();
    };

    // const mcaStep0Continue = () => {
    //      if (!emailRegEx.test(mcaAgreementDetails.email)) {
    //   setMCAFormErrors({
    //     ...mcaFormErrors,
    //     emailError: true
    //   });
    // }
    // else {
    //   setMCAFormErrors({
    //     ...mcaFormErrors,
    //     emailError: false
    //   });
    // };

    const handlePaste = (e) => {
        e.preventDefault();
    };

    return (
        <>
            {/* MCA Agreement*/}
            <Accordion.Item
                className={`mt-5 ${props.domainCheckBlockErrors || props.mcaErrorMessage?.length > 0
                        ? "accordionErrors"
                        : ""
                    } ${props.stepsCompletedCheck.isDomainCheckCompleted ? "" : "disabled"
                    }`}
                eventKey="mcaDetails"
            >
                <Accordion.Header>
                    <h3 className={`${styles["accordion-header-wrapper"]}`}>
                        <label>
                            <span className={`${styles["accordion-number"]}`}>2</span>
                        </label>
                        <label className="pl-2">
                            <span className={`${styles["accordion-name"]}`}>
                                MCA Agreement
                            </span>
                        </label>
                    </h3>
                </Accordion.Header>
                <Accordion.Body>
                    <Box sx={{ width: "100%" }} className="mb-2">
                        <Row>
                            <Col md={2}></Col>
                            <Col md={8}>
                                {activeStep !== steps?.length && (
                                    <Stepper activeStep={activeStep}>
                                        {steps.map((label, index) => {
                                            const stepProps = {};
                                            const labelProps = {};
                                            return (
                                                <Step key={label} {...stepProps}>
                                                    <StepLabel {...labelProps}>{label}</StepLabel>
                                                </Step>
                                            );
                                        })}
                                    </Stepper>
                                )}
                            </Col>
                            <Col md={2}></Col>
                        </Row>
                        {/* <Row className='px-3'>
                                            <Col md={4}>
                                                {(activeStep === 1 || activeStep === 2) && <div className='text-small mb-3 mt-3'>
                                                    <span className='text-strong'>Company name : </span>
                                                    {companyName}
                                                </div>}
                                            </Col>
                                            <Col md={8}>
                                                {activeStep === 2 && <div className='text-small mb-3 mt-3'>
                                                    <span className='text-strong'>Agreement name : </span>
                                                    {agreementName}
                                                </div>}

                                            </Col>
                                        </Row> */}
                    </Box>
                    {activeStep === 0 &&
                        props.stepsCompletedCheck.isDomainCheckCompleted && (
                            <div className={`${styles["accordion-content"]}`}>
                                <Row>
                                    <Col md={8}>
                                        <Row>
                                            <Col md={12}>
                                                <Form.Group className="mb-3" controlId="mcaFirstName">
                                                    <Form.Label>
                                                        Company Name <span className="red">*</span>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="email"
                                                        value={props.mcaAgreementDetails.companyName}
                                                        placeholder=""
                                                        readOnly={props.submittingMCA}
                                                        onChange={(e) => {
                                                            setCheckBoxStatus(false);
                                                            props.setMCAAgreementDetails({
                                                                ...props.mcaAgreementDetails,
                                                                companyName: e.target.value,
                                                            });
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="mcaFirstName">
                                                    <Form.Label>
                                                        First Name <span className="red">*</span>
                                                        <OverlayTrigger
                                                            placement="right"
                                                            overlay={
                                                                <Tooltip className={`${styles["gws-tooltip"]}`}>
                                                                    1. Avoid using only one character as part of the contact's first or family name.<br/><br/>
                                                                    2. Don't use placeholder, testing, or fake names for customer individuals, such as test, admin, or nobody.
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <span className="infoIcon-support-table infoIcon-support-table-big ml-1"></span>
                                                        </OverlayTrigger>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="firstName"
                                                        maxLength={30}
                                                        value={props.mcaAgreementDetails.firstName}
                                                        placeholder=""
                                                        readOnly={props.submittingMCA}
                                                        onChange={(e) => {
                                                            setCheckBoxStatus(false);
                                                            if (
                                                                e.target.value === "" ||
                                                                mcaAgreementDetnameRegEx.test(e.target.value)
                                                            ) {
                                                                props.setMCAAgreementDetails({
                                                                    ...props.mcaAgreementDetails,
                                                                    firstName: e.target.value,
                                                                });
                                                            }
                                                        }}
                                                    />
                                                    {props.mcaAgreementDetails.firstName == "" ||
                                                        mcaAgreementDetnameRegEx.test(
                                                            props.mcaAgreementDetails.firstName
                                                        ) ? (
                                                        ""
                                                    ) : (
                                                        <span className="red text-small">
                                                            Enter first name
                                                        </span>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="mcaLastName">
                                                    <Form.Label>
                                                        Last Name <span className="red">*</span>
                                                        <OverlayTrigger
                                                            placement="right"
                                                            overlay={
                                                                <Tooltip className={`${styles["gws-tooltip"]}`}>
                                                                    1. Avoid using only one character as part of the contact's first or family name.<br/><br/>
                                                                    2. Don't use placeholder, testing, or fake names for customer individuals, such as test, admin, or nobody.
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <span className="infoIcon-support-table infoIcon-support-table-big ml-1"></span>
                                                        </OverlayTrigger>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="lastName"
                                                        value={props.mcaAgreementDetails.lastName}
                                                        placeholder=""
                                                        readOnly={props.submittingMCA}
                                                        maxLength={30}
                                                        onChange={(e) => {
                                                            setCheckBoxStatus(false);
                                                            if (
                                                                e.target.value === "" ||
                                                                mcaAgreementDetnameRegEx.test(e.target.value)
                                                            ) {
                                                                props.setMCAAgreementDetails({
                                                                    ...props.mcaAgreementDetails,
                                                                    lastName: e.target.value,
                                                                });
                                                            }
                                                        }}
                                                    />
                                                    {props.mcaAgreementDetails.lastName == "" ||
                                                        mcaAgreementDetnameRegEx.test(
                                                            props.mcaAgreementDetails.lastName
                                                        ) ? (
                                                        ""
                                                    ) : (
                                                        <span className="red text-small">
                                                            Enter last name
                                                        </span>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="mcaFirstName">
                                                    <Form.Label>
                                                        Email ID <span className="red">*</span>
                                                        <OverlayTrigger
                                                            placement="right"
                                                            overlay={
                                                                <Tooltip className={`${styles["gws-tooltip"]}`}>
                                                                    1. The address can't contain @microsoft.com.<br/><br/>
                                                                    2. The address can't contain the same domain name as the partner.
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <span className="infoIcon-support-table infoIcon-support-table-big ml-1"></span>
                                                        </OverlayTrigger>
                                                    </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="email"
                                                        value={props.mcaAgreementDetails.email}
                                                        placeholder=""
                                                        readOnly={props.submittingMCA}
                                                        onChange={(e) => {
                                                            setCheckBoxStatus(false);
                                                            props.setMCAAgreementDetails({
                                                                ...props.mcaAgreementDetails,
                                                                email: e.target.value,
                                                            });

                                                            props.setMCAFormErrors({
                                                                ...props.mcaFormErrors,
                                                                emailError: false,
                                                            });
                                                        }}
                                                    />
                                                    {props.mcaFormErrors.emailError == true && (
                                                        <span className="red text-small">
                                                            Enter valid email
                                                        </span>
                                                    )}
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className="mb-3" controlId="phoneNumber">
                                                    <Form.Label>Phone Number (Optional)</Form.Label>
                                                    <Row>
                                                        <Col>
                                                            <div className="phone-number-wrapper">
                                                                <label>+61</label>
                                                                <Form.Control
                                                                    type="text"
                                                                    className="phone-number form-control col"
                                                                    placeholder="xxxxxxxxxx"
                                                                    name="phoneNumber"
                                                                    value={props.mcaAgreementDetails.phoneNumber}
                                                                    readOnly={props.submittingMCA}
                                                                    maxLength="15"
                                                                    onChange={(e) => {
                                                                        setCheckBoxStatus(false);
                                                                        const inputValue = e.target.value;
                                                                        if (
                                                                            inputValue === "" ||
                                                                            phoneOnChangeRegex.test(inputValue)
                                                                        ) {
                                                                            props.setMCAAgreementDetails({
                                                                                ...props.mcaAgreementDetails,
                                                                                phoneNumber: inputValue,
                                                                            });
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Form.Group>
                                            </Col>
                                            {/* <Col md={6}>
                                            <Form.Group className="mb-3" controlId="mcaFirstName">
                                                <Form.Label>MCA Terms Accepted on (as per UTC Time) <span className="red">*</span></Form.Label>

                                                <Form.Control
                                                    type="date"
                                                    onKeyDown={handleKeyDown}
                                                    onPaste={handlePaste}
                                                    max={new Date().toISOString().split('T')[0]}
                                                    min={minMCAAgreementDate}
                                                    readOnly={props.submittingMCA}
                                                    onChange={(e) => {
                                                        props.setMCAAgreementDetails({
                                                            ...props.mcaAgreementDetails,
                                                            mcaAcceptanceDate: e.target.value.split('-')
                                                        });
                                                        props.setValidDate(true);
                                                    }
                                                    }
                                                />
                                                {props.validDate == false && <span className="red text-small">Select acceptance date</span>}
                                            </Form.Group>
                                        </Col> */}
                                            {/* <Col md={12}>
                                            <p><a href={props.mcaDownloadUri} target='_blank'
                                                className="link-text" rel="noreferrer">Click here</a> to view Microsoft Customer Agreement</p>
                                            <p>You must provide the confirmation of customer’s acceptance of MCA to provision the subscriptions</p>
                                        </Col> */}
                                        </Row>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="text-right">
                                        <div className="button-wrapper">
                                            {props.submittingMCA == false && (
                                                <>
                                                    {props.isDomainType.isDomainTransition ? (
                                                        <Button
                                                            className="btn btn-lg btn-border-light px-4"
                                                            variant="light"
                                                            onClick={() =>
                                                                props.setActiveAccordion(["transitionDomain"])
                                                            }
                                                        >
                                                            Back
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            className="btn btn-lg btn-border-light px-4"
                                                            variant="light"
                                                            onClick={() =>
                                                                props.setActiveAccordion(["domainCheck"])
                                                            }
                                                        >
                                                            Back
                                                        </Button>
                                                    )}
                                                </>
                                            )}

                                            {/* {
                                        props.submittingMCA == true &&
                                            <>
                                                <Button
                                                    className="btn btn-lg btn-border-light px-4"
                                                    variant="light"
                                                    disabled
                                                >
                                                    Back
                                                </Button>
                                                <Button
                                                    className="btn btn-lg ml-2 px-4"
                                                    variant="light"
                                                    disabled
                                                >
                                                    Submitting...
                                                </Button>
                                            </>
                                        } */}
                                            {props.submittingMCA == false && (
                                                <>
                                                    {props.ismcaFormHasNoErros == true ? (
                                                        <Button
                                                            className="btn btn-lg ml-2 px-4"
                                                            onClick={(e) => {
                                                                setCheckBoxStatus(false);
                                                                props.generateAttestation(setActiveStep);
                                                            }}
                                                        >
                                                            Continue
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            className="btn btn-lg ml-2 px-4"
                                                            variant="light"
                                                            disabled
                                                        >
                                                            Continue
                                                        </Button>
                                                    )}
                                                </>
                                            )}
                                            {props.submittingMCA == true && (
                                                <>
                                                    <Button
                                                        className="btn btn-lg btn-border-light px-4"
                                                        variant="light"
                                                        disabled
                                                    >
                                                        Back
                                                    </Button>
                                                    <Button
                                                        className="btn btn-lg ml-2 px-4"
                                                        variant="light"
                                                        disabled
                                                    >
                                                        Processing . . .
                                                    </Button>
                                                </>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        )}
                    {activeStep === 1 &&
                        props.stepsCompletedCheck.isDomainCheckCompleted && (
                            <div className={`${styles["accordion-content"]}`}>
                                {!iframe && (
                                    <>
                                        <Row>
                                            <Col md={8}>
                                                <Row>
                                                    <Col md={12}>
                                                        <Form.Group
                                                            className="mb-3"
                                                            controlId="mcaFirstName"
                                                        >
                                                            <Form.Label>
                                                                Company Name <span className="red">*</span>
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="email"
                                                                value={props.mcaAgreementDetails.companyName}
                                                                placeholder=""
                                                                disabled
                                                                readOnly={props.submittingMCA}
                                                                onChange={(e) => {
                                                                    props.setMCAAgreementDetails({
                                                                        ...props.mcaAgreementDetails,
                                                                        email: e.target.value,
                                                                    });

                                                                    props.setMCAFormErrors({
                                                                        ...props.mcaFormErrors,
                                                                        emailError: false,
                                                                    });
                                                                }}
                                                            />
                                                            {props.mcaFormErrors.emailError == true && (
                                                                <span className="red text-small">
                                                                    Enter valid company Name
                                                                </span>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group
                                                            className="mb-3"
                                                            controlId="mcaFirstName"
                                                        >
                                                            <Form.Label>
                                                                First name <span className="red">*</span>
                                                                <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                        <Tooltip className={`${styles["gws-tooltip"]}`}>
                                                                            1. Avoid using only one character as part of the contact's first or family name.<br/><br/>
                                                                            2. Don't use placeholder, testing, or fake names for customer individuals, such as test, admin, or nobody.
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="infoIcon-support-table infoIcon-support-table-big ml-1"></span>
                                                                </OverlayTrigger>
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="firstName"
                                                                maxLength={30}
                                                                disabled
                                                                value={props.mcaAgreementDetails.firstName}
                                                                placeholder=""
                                                                readOnly={props.submittingMCA}
                                                                onChange={(e) => {
                                                                    if (
                                                                        e.target.value === "" ||
                                                                        mcaAgreementDetnameRegEx.test(
                                                                            e.target.value
                                                                        )
                                                                    ) {
                                                                        props.setMCAAgreementDetails({
                                                                            ...props.mcaAgreementDetails,
                                                                            firstName: e.target.value,
                                                                        });
                                                                    }
                                                                }}
                                                            />
                                                            {props.mcaAgreementDetails.firstName == "" ||
                                                                mcaAgreementDetnameRegEx.test(
                                                                    props.mcaAgreementDetails.firstName
                                                                ) ? (
                                                                ""
                                                            ) : (
                                                                <span className="red text-small">
                                                                    Enter first name
                                                                </span>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group
                                                            className="mb-3"
                                                            controlId="mcaLastName"
                                                        >
                                                            <Form.Label>
                                                                Last name <span className="red">*</span>
                                                                <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                        <Tooltip className={`${styles["gws-tooltip"]}`}>
                                                                            1. Avoid using only one character as part of the contact's first or family name.<br/><br/>
                                                                            2. Don't use placeholder, testing, or fake names for customer individuals, such as test, admin, or nobody.
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="infoIcon-support-table infoIcon-support-table-big ml-1"></span>
                                                                </OverlayTrigger>
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="lastName"
                                                                value={props.mcaAgreementDetails.lastName}
                                                                placeholder=""
                                                                disabled
                                                                readOnly={props.submittingMCA}
                                                                maxLength={30}
                                                                onChange={(e) => {
                                                                    if (
                                                                        e.target.value === "" ||
                                                                        mcaAgreementDetnameRegEx.test(
                                                                            e.target.value
                                                                        )
                                                                    ) {
                                                                        props.setMCAAgreementDetails({
                                                                            ...props.mcaAgreementDetails,
                                                                            lastName: e.target.value,
                                                                        });
                                                                    }
                                                                }}
                                                            />
                                                            {props.mcaAgreementDetails.lastName == "" ||
                                                                mcaAgreementDetnameRegEx.test(
                                                                    props.mcaAgreementDetails.lastName
                                                                ) ? (
                                                                ""
                                                            ) : (
                                                                <span className="red text-small">
                                                                    Enter last name
                                                                </span>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group
                                                            className="mb-3"
                                                            controlId="mcaFirstName"
                                                        >
                                                            <Form.Label>
                                                                Email ID <span className="red">*</span>
                                                                <OverlayTrigger
                                                                    placement="right"
                                                                    overlay={
                                                                        <Tooltip className={`${styles["gws-tooltip"]}`}>
                                                                            1. The address can't contain @microsoft.com.<br/><br/>
                                                                            2. The address can't contain the same domain name as the partner.
                                                                        </Tooltip>
                                                                    }
                                                                >
                                                                    <span className="infoIcon-support-table infoIcon-support-table-big ml-1"></span>
                                                                </OverlayTrigger>
                                                            </Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="email"
                                                                disabled
                                                                value={props.mcaAgreementDetails.email}
                                                                placeholder=""
                                                                readOnly={props.submittingMCA}
                                                                onChange={(e) => {
                                                                    props.setMCAAgreementDetails({
                                                                        ...props.mcaAgreementDetails,
                                                                        email: e.target.value,
                                                                    });

                                                                    props.setMCAFormErrors({
                                                                        ...props.mcaFormErrors,
                                                                        emailError: false,
                                                                    });
                                                                }}
                                                            />
                                                            {props.mcaFormErrors.emailError == true && (
                                                                <span className="red text-small">
                                                                    Enter valid email
                                                                </span>
                                                            )}
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={6}>
                                                        <Form.Group
                                                            className="mb-3"
                                                            controlId="phoneNumber"
                                                        >
                                                            <Form.Label>Phone Number (Optional)</Form.Label>
                                                            <Row>
                                                                <Col>
                                                                    <div className="phone-number-wrapper">
                                                                        <label>+61</label>
                                                                        <Form.Control
                                                                            type="text"
                                                                            disabled
                                                                            className="phone-number form-control col"
                                                                            placeholder="xxxxxxxxxx"
                                                                            name="phoneNumber"
                                                                            value={
                                                                                props.mcaAgreementDetails.phoneNumber
                                                                            }
                                                                            readOnly={props.submittingMCA}
                                                                            maxLength="15"
                                                                            onChange={(e) => {
                                                                                const inputValue = e.target.value;
                                                                                if (
                                                                                    inputValue === "" ||
                                                                                    phoneOnChangeRegex.test(inputValue)
                                                                                ) {
                                                                                    props.setMCAAgreementDetails({
                                                                                        ...props.mcaAgreementDetails,
                                                                                        phoneNumber: inputValue,
                                                                                    });
                                                                                }
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Form.Group>
                                                    </Col>
                                                    {/* <Col md={6}>
                                            <Form.Group className="mb-3" controlId="mcaFirstName">
                                                <Form.Label>MCA Terms Accepted on (as per UTC Time) <span className="red">*</span></Form.Label>

                                                <Form.Control
                                                    type="date"
                                                    onKeyDown={handleKeyDown}
                                                    onPaste={handlePaste}
                                                    max={new Date().toISOString().split('T')[0]}
                                                    min={minMCAAgreementDate}
                                                    readOnly={props.submittingMCA}
                                                    onChange={(e) => {
                                                        props.setMCAAgreementDetails({
                                                            ...props.mcaAgreementDetails,
                                                            mcaAcceptanceDate: e.target.value.split('-')
                                                        });
                                                        props.setValidDate(true);
                                                    }
                                                    }
                                                />
                                                {props.validDate == false && <span className="red text-small">Select acceptance date</span>}
                                            </Form.Group>
                                        </Col> */}
                                                    <Col md={12}>
                                                        <Form.Check
                                                            type="checkbox"
                                                            id="termsCheckBox"
                                                            checked={checkBoxStatus}
                                                            disabled
                                                            className="d-inline-block w-auto"
                                                        />
                                                        <p className="d-inline-block ml-1  w-auto mb-0">
                                                            {" "}
                                                            Click on Continue to accept your Microsoft
                                                            Customer Agreement
                                                        </p>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col className="text-right">
                                                <div className="button-wrapper">
                                                    {/* {props.submittingMCA == false &&
                                            <>
                                               <Button
                                                        className="btn btn-lg btn-border-light px-4"
                                                        variant="light"
                                                        // onClick={() => props.setActiveAccordion(["transitionDomain"])}
                                                        onClick={(e) => {
                                                            // props.submitMCAForm();
                                                            setActiveStep(0);
                                                        }
                                                        }
                                                    >
                                                        Back
                                                    </Button>
                                                
                                            </>
                                        } */}

                                                    {/* {props.submittingMCA == true &&
                                            <>
                                                <Button
                                                    className="btn btn-lg btn-border-light px-4"
                                                    variant="light"
                                                    disabled
                                                >
                                                    Back
                                                </Button>
                                                <Button
                                                    className="btn btn-lg ml-2 px-4"
                                                    variant="light"
                                                    disabled
                                                >
                                                    Submitting...
                                                </Button>
                                            </>
                                        } */}
                                        
                                                        <Button
                                                            className="btn btn-lg btn-border-light ml-2 px-4"
                                                            variant="light"
                                                            onClick={(e) => {
                                                                // props.submitMCAForm();
                                                                setActiveStep(0);
                                                            }}
                                                        >
                                                            Back
                                                        </Button>

                                                    <Button
                                                            className="btn btn-lg ml-2 px-4"
                                                            onClick={(e) => {
                                                                // props.submitMCAForm();
                                                                if(checkBoxStatus===true){
                                                                    setActiveStep(2);
                                                                }else{
                                                                  setIframe(true);  
                                                                }
                                                            }}
                                                        >
                                                            Continue
                                                        </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </>
                                )}

                                {
                                    iframe && (
                                        <Popup
                                            className="custom-modal custom-modal-integration-xl ms-cust-agreement-popup"
                                            open={iframe}
                                            onClose={() => {
                                                setIframe(false);
                                            }}
                                            closeOnDocumentClick={false}
                                            modal
                                            nested
                                        >
                                            {(close) => (
                                                <div className="modal">
                                                    <div className="header p-4 py-3">
                                                        <h2 className="mb-0 px-3">
                                                            Microsoft Customer Agreement
                                                        </h2>
                                                        <XLg
                                                            size={18}
                                                            className="cpointer text-strong close-icon-popup-sm"
                                                            onClick={close}
                                                            color={TEXT_SECONDARY}
                                                        />
                                                    </div>
                                                    <Container className="p-0 pb-1">
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "center",
                                                                alignItems: "center",
                                                                margin: 0,
                                                            }}
                                                        >
                                                            <iframe
                                                                width="100%"
                                                                src={"https://cdn.partner.microsoft.com/mca/?attestationid=" + props.attestationId}
                                                                title="MCA Aggrement Form"
                                                                className="ms-cust-agreement-popup-iframe"
                                                                frameborder="0"
                                                                referrerpolicy="strict-origin-when-cross-origin"
                                                            ></iframe>
                                                        </div>
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                justifyContent: "flex-end",
                                                                alignItems: "center",
                                                                margin: 0,
                                                            }}
                                                            className="mt-4"
                                                        >
                                                            <p className="mb-0">Once you accept the agreement, click here</p>
                                                            <Button
                                                                className="px-4 mx-2"
                                                                onClick={() => {
                                                                    close();
                                                                    setCheckBoxStatus(true);
                                                                    setActiveStep(2);
                                                                }}
                                                            >
                                                                Continue
                                                            </Button>
                                                        </div>
                                                    </Container>
                                                </div>
                                            )}
                                        </Popup>
                                    )
                                    // <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 0 }}>
                                    //      <iframe width="560" height="315" src="https://www.youtube.com/embed/gLptmcuCx6Q?si=mt8jlUkBxe5pwGE6" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                    //     </div>
                                }
                            </div>
                        )}
                    {activeStep === 2 && (
                        <div className={`${styles["accordion-content"]}`}>
                            <Row>
                                <Col md={8}>
                                    <Row>
                                        <Col md={12}>
                                            <Form.Group className="mb-3" controlId="mcaFirstName">
                                                <Form.Label>
                                                    Company Name <span className="red">*</span>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="email"
                                                    value={props.mcaAgreementDetails.companyName}
                                                    placeholder=""
                                                    disabled
                                                    readOnly={props.submittingMCA}
                                                    onChange={(e) => {
                                                        props.setMCAAgreementDetails({
                                                            ...props.mcaAgreementDetails,
                                                            email: e.target.value,
                                                        });

                                                        props.setMCAFormErrors({
                                                            ...props.mcaFormErrors,
                                                            emailError: false,
                                                        });
                                                    }}
                                                />
                                                {props.mcaFormErrors.emailError == true && (
                                                    <span className="red text-small">
                                                        Enter valid company Name
                                                    </span>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3" controlId="mcaFirstName">
                                                <Form.Label>
                                                    First Name <span className="red">*</span>
                                                    <OverlayTrigger
                                                        placement="right"
                                                        overlay={
                                                            <Tooltip className={`${styles["gws-tooltip"]}`}>
                                                                1. Avoid using only one character as part of the contact's first or family name.<br/><br/>
                                                                2. Don't use placeholder, testing, or fake names for customer individuals, such as test, admin, or nobody.
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span className="infoIcon-support-table infoIcon-support-table-big ml-1"></span>
                                                    </OverlayTrigger>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="firstName"
                                                    maxLength={30}
                                                    disabled
                                                    value={props.mcaAgreementDetails.firstName}
                                                    placeholder=""
                                                    readOnly={props.submittingMCA}
                                                    onChange={(e) => {
                                                        if (
                                                            e.target.value === "" ||
                                                            mcaAgreementDetnameRegEx.test(e.target.value)
                                                        ) {
                                                            props.setMCAAgreementDetails({
                                                                ...props.mcaAgreementDetails,
                                                                firstName: e.target.value,
                                                            });
                                                        }
                                                    }}
                                                />
                                                {props.mcaAgreementDetails.firstName == "" ||
                                                    mcaAgreementDetnameRegEx.test(
                                                        props.mcaAgreementDetails.firstName
                                                    ) ? (
                                                    ""
                                                ) : (
                                                    <span className="red text-small">
                                                        Enter first name
                                                    </span>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3" controlId="mcaLastName">
                                                <Form.Label>
                                                    Last Name <span className="red">*</span>
                                                    <OverlayTrigger
                                                        placement="right"
                                                        overlay={
                                                            <Tooltip className={`${styles["gws-tooltip"]}`}>
                                                                1. Avoid using only one character as part of the contact's first or family name.<br/><br/>
                                                                2. Don't use placeholder, testing, or fake names for customer individuals, such as test, admin, or nobody.
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span className="infoIcon-support-table infoIcon-support-table-big ml-1"></span>
                                                    </OverlayTrigger>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="lastName"
                                                    value={props.mcaAgreementDetails.lastName}
                                                    placeholder=""
                                                    disabled
                                                    readOnly={props.submittingMCA}
                                                    maxLength={30}
                                                    onChange={(e) => {
                                                        if (
                                                            e.target.value === "" ||
                                                            mcaAgreementDetnameRegEx.test(e.target.value)
                                                        ) {
                                                            props.setMCAAgreementDetails({
                                                                ...props.mcaAgreementDetails,
                                                                lastName: e.target.value,
                                                            });
                                                        }
                                                    }}
                                                />
                                                {props.mcaAgreementDetails.lastName == "" ||
                                                    mcaAgreementDetnameRegEx.test(
                                                        props.mcaAgreementDetails.lastName
                                                    ) ? (
                                                    ""
                                                ) : (
                                                    <span className="red text-small">
                                                        Enter last name
                                                    </span>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3" controlId="mcaFirstName">
                                                <Form.Label>
                                                    Email ID <span className="red">*</span>
                                                    <OverlayTrigger
                                                        placement="right"
                                                        overlay={
                                                            <Tooltip className={`${styles["gws-tooltip"]}`}>
                                                                1. The address can't contain @microsoft.com.<br/><br/>
                                                                2. The address can't contain the same domain name as the partner.
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span className="infoIcon-support-table infoIcon-support-table-big ml-1"></span>
                                                    </OverlayTrigger>
                                                </Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="email"
                                                    disabled
                                                    value={props.mcaAgreementDetails.email}
                                                    placeholder=""
                                                    readOnly={props.submittingMCA}
                                                    onChange={(e) => {
                                                        props.setMCAAgreementDetails({
                                                            ...props.mcaAgreementDetails,
                                                            email: e.target.value,
                                                        });

                                                        props.setMCAFormErrors({
                                                            ...props.mcaFormErrors,
                                                            emailError: false,
                                                        });
                                                    }}
                                                />
                                                {props.mcaFormErrors.emailError == true && (
                                                    <span className="red text-small">
                                                        Enter valid email
                                                    </span>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3" controlId="phoneNumber">
                                                <Form.Label>Phone Number (Optional)</Form.Label>
                                                <Row>
                                                    <Col>
                                                        <div className="phone-number-wrapper">
                                                            <label>+61</label>
                                                            <Form.Control
                                                                type="text"
                                                                disabled
                                                                className="phone-number form-control col"
                                                                placeholder="xxxxxxxxxx"
                                                                name="phoneNumber"
                                                                value={props.mcaAgreementDetails.phoneNumber}
                                                                readOnly={props.submittingMCA}
                                                                maxLength="15"
                                                                onChange={(e) => {
                                                                    const inputValue = e.target.value;
                                                                    if (
                                                                        inputValue === "" ||
                                                                        phoneOnChangeRegex.test(inputValue)
                                                                    ) {
                                                                        props.setMCAAgreementDetails({
                                                                            ...props.mcaAgreementDetails,
                                                                            phoneNumber: inputValue,
                                                                        });
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Form.Group>
                                        </Col>
                                        {/* <Col md={6}>
                                            <Form.Group className="mb-3" controlId="mcaFirstName">
                                                <Form.Label>MCA Terms Accepted on (as per UTC Time) <span className="red">*</span></Form.Label>

                                                <Form.Control
                                                    type="date"
                                                    onKeyDown={handleKeyDown}
                                                    onPaste={handlePaste}
                                                    max={new Date().toISOString().split('T')[0]}
                                                    min={minMCAAgreementDate}
                                                    readOnly={props.submittingMCA}
                                                    onChange={(e) => {
                                                        props.setMCAAgreementDetails({
                                                            ...props.mcaAgreementDetails,
                                                            mcaAcceptanceDate: e.target.value.split('-')
                                                        });
                                                        props.setValidDate(true);
                                                    }
                                                    }
                                                />
                                                {props.validDate == false && <span className="red text-small">Select acceptance date</span>}
                                            </Form.Group>
                                        </Col> */}
                                        <Col md={12}>
                                            <Form.Check
                                                type="checkbox"
                                                id="termsCheckBox"
                                                checked={checkBoxStatus}
                                                disabled
                                                className="d-inline-block w-auto"
                                            />
                                            <p className="d-inline-block ml-1  w-auto mb-0">
                                                {" "}
                                                Click on Continue to accept your Microsoft Customer
                                                Agreement
                                            </p>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="text-right">
                                    <div className="button-wrapper my-2 mr-2">
                                        {/* {props.submittingMCA == false &&
                                            <>
                                               <Button
                                                        className="btn btn-lg btn-border-light px-4"
                                                        variant="light"
                                                        // onClick={() => props.setActiveAccordion(["transitionDomain"])}
                                                        onClick={(e) => {
                                                            // props.submitMCAForm();
                                                            setActiveStep(0);
                                                        }
                                                        }
                                                    >
                                                        Back
                                                    </Button>
                                                
                                            </>
                                        } */}

                                        {/* {props.submittingMCA == true &&
                                            <>
                                                <Button
                                                    className="btn btn-lg btn-border-light px-4"
                                                    variant="light"
                                                    disabled
                                                >
                                                    Back
                                                </Button>
                                                <Button
                                                    className="btn btn-lg ml-2 px-4"
                                                    variant="light"
                                                    disabled
                                                >
                                                    Submitting...
                                                </Button>
                                            </>
                                        } */}
                                        {props.submittingMCA == false && <Button
                                            className="btn btn-lg btn-border-light ml-2 px-4"
                                            variant="light"
                                            onClick={(e) => {
                                                // props.submitMCAForm();
                                                setActiveStep(1);
                                            }}
                                        >
                                            Back
                                        </Button>}
                                        {props.submittingMCA == false  && (checkBoxStatus == true ? (
                                            <Button
                                                className="btn btn-lg ml-2 px-4"
                                                onClick={(e) => {
                                                    props.saveMCAAgreementDetails();
                                                }}
                                            >
                                                Submit
                                            </Button>
                                        ) : (
                                            <Button
                                                className="btn btn-lg ml-2 px-4"
                                                variant="light"
                                                disabled
                                            >
                                                Submit
                                            </Button>
                                        ))}
                                        {props.submittingMCA == true && (
                                                <>
                                                    <Button
                                                        className="btn btn-lg btn-border-light px-4"
                                                        variant="light"
                                                        disabled
                                                    >
                                                        Back
                                                    </Button>
                                                    <Button
                                                        className="btn btn-lg ml-2 px-4"
                                                        variant="light"
                                                        disabled
                                                    >
                                                        Processing . . .
                                                    </Button>
                                                </>
                                            )}
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    )}
                </Accordion.Body>
            </Accordion.Item>
            {props.submittingMCA == false &&
                props.mcaErrorMessageFlag == true &&
                props.mcaErrorMessage?.length == 0 ? (
                <p className="red text-small mt-3">{MCAError}</p>
            ) : (
                <p className="red text-small mt-3">{props.mcaErrorMessage}</p>
            )}
        </>
    );
};

export default MCAAgreement;
